var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5646 0.272772L0.985975 10.0647C-0.0835843 10.5207 -0.445347 11.4339 0.727416 11.9294L7.54603 13.9996L24.0324 4.26546C24.9326 3.65434 25.8541 3.81731 25.0612 4.48953L10.9016 16.7379L10.4567 21.9214C10.8687 22.7217 11.6231 22.7254 12.1042 22.3276L16.0217 18.7863L22.731 23.5861C24.2893 24.4675 25.1372 23.8987 25.4724 22.2833L29.8731 2.37554C30.3301 0.38705 29.5508 -0.489076 27.5646 0.272772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTg);
export default __webpack_public_path__ + "static/media/serviceTg.148888ef46f6394a92a0e8fbec93d819.svg";
export { ForwardRef as ReactComponent };